import * as React from "react"

import Tooltip from "./Tooltip"
import {
    ContextualHelpDictionary,
    ContextualHelpTerm,
} from "../../../../../models"

interface Props {
    openedTooltip: Element | null
    tooltips: [Element | null, ContextualHelpDictionary[]][]
    setTooltip: (
        element: Element | null,
        term: ContextualHelpTerm | null,
    ) => void
}

export const Tooltips = ({
    openedTooltip,
    tooltips,
    setTooltip,
}: Props): JSX.Element => {
    const mappedTooltips = tooltips.map((visibleTooltip) => {
        const target = visibleTooltip[0]
        const dictionarySources = visibleTooltip[1]
        if (target === null || dictionarySources.length === 0) {
            return <></>
        }

        return (
            <Tooltip
                dictionarySources={dictionarySources}
                isContentShown={openedTooltip === target}
                isAnyContentShown={!!openedTooltip}
                key={dictionarySources
                    .flatMap((dictSrc) => dictSrc.terms)
                    .map((term) => term.code)
                    .join("-")}
                target={target}
                toggleTooltip={setTooltip}
            />
        )
    })

    return <>{mappedTooltips}</>
}

export default Tooltips
